/**
 * @generated SignedSource<<212c4cb514e4399215b44736ad6b09ef>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type accountDropzone_PresignQuery$variables = {
  fileExtension: string;
};
export type accountDropzone_PresignQuery$data = {
  readonly uploadPresign: {
    readonly signedUrl: string;
    readonly storageKey: string;
  } | null | undefined;
};
export type accountDropzone_PresignQuery = {
  response: accountDropzone_PresignQuery$data;
  variables: accountDropzone_PresignQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "fileExtension"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "fileExtension",
    "variableName": "fileExtension"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "signedUrl",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "storageKey",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "accountDropzone_PresignQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UploadPresign",
        "kind": "LinkedField",
        "name": "uploadPresign",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "accountDropzone_PresignQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UploadPresign",
        "kind": "LinkedField",
        "name": "uploadPresign",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "df541f7d0e935eca8da51258c90f672d",
    "id": null,
    "metadata": {},
    "name": "accountDropzone_PresignQuery",
    "operationKind": "query",
    "text": "query accountDropzone_PresignQuery(\n  $fileExtension: String!\n) {\n  uploadPresign(fileExtension: $fileExtension) {\n    signedUrl\n    storageKey\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "545baecdd9e00d3c89b272cfbcf31b76";

export default node;
